export default {"src":"/_next/static/media/default-avt.904af5ca.svg","height":19,"width":20};